import React from 'react'
import { MainLayout, Meta, SectionTitle, StructuredMeta } from 'app/components'
import {
  Button,
  Container,
  isWeb,
  ScrollView,
  SizableText,
  Spinner,
  XStack,
  YStack,
} from '@my/ui'
import { ArticlesQueryOutput, BlogHomeQueryOutput } from './queries'
import { ArticleBlockRenderer } from '../../blocks'
import { ArticleGrid, EmptyArticles } from '../../components'
import { CategoryTabs } from '../../containers'
import { RefreshControl } from 'react-native'
import config from 'app/config'

export interface AdviceScreenProps {
  loading: boolean
  fetchingMore: boolean
  hasArticles: boolean
  hasMore: boolean
  content: BlogHomeQueryOutput['BlogHome']['content']
  meta?: BlogHomeQueryOutput['BlogHome']['meta']
  moreArticles: ArticlesQueryOutput['Articles']['docs']
  onLoadMore: () => void

  refreshing: boolean
  onPullToRefresh: () => void
}

export const AdviceScreen = (props: AdviceScreenProps) => {
  return (
    <MainLayout>
      <Meta
        title={props.meta?.title || 'Student & Uni Advice'}
        description={props.meta?.description || 'How To Make & Save Money at Uni.'}
      />
      <StructuredMeta
        type="breadcrumb"
        breadcrumbs={[
          {
            name: 'Home',
            url: config.siteUrl,
          },
          {
            name: 'Life',
            url: `${config.siteUrl}/life`,
          },
        ]}
      />
      {isWeb && <CategoryTabs />}
      <ScrollView
        width="100%"
        refreshControl={
          <RefreshControl refreshing={props.refreshing} onRefresh={props.onPullToRefresh} />
        }
      >
        <Container spaceTop spaceBottom>
          <Container size="base" gutter>
            <YStack w="100%" gap={4}>
              <SectionTitle color="$overlay12">Uni Life Advice</SectionTitle>
              <SizableText color="$overlay11" fow="500">
                Tips & guides on how to save money, make money, and make the most at your time at
                uni.
              </SizableText>
              {props.hasArticles && (
                <SizableText pb="$4" color="$overlay11" fow="500">
                  Search above or scroll through to what’s on offer below!
                </SizableText>
              )}
            </YStack>
          </Container>

          {props.loading && (
            <Container size="base" flex={1} minHeight={100} jc="center">
              <Spinner />
            </Container>
          )}
          <ArticleBlockRenderer content={props.content} />
          {props.hasArticles && (props.moreArticles?.length || 0) > 0 && (
            <Container gutter size="base">
              <YStack flex={1} width="100%" gap="$2">
                <SectionTitle>More Posts</SectionTitle>
                <ArticleGrid articles={props.moreArticles} />
                {props.hasMore && (
                  <XStack jc="center" mt="$4">
                    <Button
                      theme="primary"
                      size="$4"
                      loading={props.fetchingMore}
                      onPress={props.onLoadMore}
                    >
                      Load more
                    </Button>
                  </XStack>
                )}
              </YStack>
            </Container>
          )}
          {!props.loading && !props.hasArticles && <EmptyArticles />}
        </Container>
      </ScrollView>
    </MainLayout>
  )
}
